import Input from "./index.vue";

Input.install = function (Vue) {
  Vue.component(Input.name, Input);
};

export default Input;